import { render, staticRenderFns } from "./semifisheds-table.vue?vue&type=template&id=7300c22b&"
import script from "./semifisheds-table.vue?vue&type=script&lang=js&"
export * from "./semifisheds-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports